import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { NexPage } from "../components/Table/pageable-table/NexPage"
import { PagingFilters, generateSearchParamsForDjango } from "../components/Table/pageable-table/PagingFilters"
import { ReceiptShippingInfoDto, ShipmentDetails } from "../models/DataReceipt"
import { DataReceiptTableFilters } from "../models/DataReceiptQueries"
import { DataReceiptSearchFitlersAndPaging } from "../pages/DataReceipt/table-view/DataReceiptSearchFilters"
import { prettyJson } from "../tools"
import { SelectMissionsOrder } from "../zstore/DataReceiptTableSlice"
import { API, NexusResponse } from "./API"
import { QueryKeys } from "./QueryConfig"

export const useFindShipmentInformation = (filters: PagingFilters<SelectMissionsOrder> & DataReceiptTableFilters) => {
    const searchParams = generateSearchParamsForDjango(filters)

    return useQuery({
        queryKey: [QueryKeys.FIND_MISSION_SHIPMENT_INFO, filters],
        queryFn: async () => {
            const result: NexusResponse<NexPage<ReceiptShippingInfoDto>> = await API.get(
                `/mission-shipments/available?${searchParams.toString()}`,
                "Couldn't fetch the shipping info",
            )
            return result.data
        },
        placeholderData: keepPreviousData,
        refetchOnWindowFocus: false,
    })
}

export enum DataReceiptsOrder {
    DATE_RECEIVED = "receipt__date_received",
}

export const useFindDataReceipts = (queries: DataReceiptSearchFitlersAndPaging) => {
    const searchParams = generateSearchParamsForDjango(queries)

    return useQuery({
        queryKey: [QueryKeys.FIND_DATA_RECEIPT, queries],
        queryFn: async () => {
            const result: NexusResponse<NexPage<ShipmentDetails>> = await API.get(
                `/data-receipts-with-missions?${searchParams.toString()}`,
                `Couldn't fetch data receipts with filters: ${prettyJson(queries)}`,
            )
            return result.data
        },
        placeholderData: keepPreviousData,
        refetchOnWindowFocus: false,
    })
}
